module.exports = __webpack_public_path__ + "img/getSuccess.1411521c.png";